export const computePrendasUnidadesPedido = (_pedidoPayload, modoAlta) => {
  const modo = String(modoAlta || "ambos")
    .trim()
    .toLowerCase();
  const soloCompraAlta = modo === "compra";
  const lineas = Array.isArray(_pedidoPayload?.lineasTallas)
    ? _pedidoPayload.lineasTallas
    : [];
  const matriz = lineas.reduce(
    (s, l) => s + (Number(l?.unidades ?? l?.Unidades) || 0),
    0,
  );
  if (matriz > 0) return matriz;
  if (soloCompraAlta) return 0;
  const uv = Number(String(_pedidoPayload?.unidadesVenta ?? "").replace(",", "."));
  return Number.isFinite(uv) ? uv : 0;
};
